import { PastFillingsStateValues, updateKey } from './slice';
import * as Yup from 'yup';
import { updateKeyInStore } from 'App';
import { yearSelectOptions } from 'utils/yearSelectOptions';
import { states } from 'states';
import { requiredFiles } from '../../../useValidateQuestionnaire';

export const fields: IBaseField<keyof PastFillingsStateValues>[] = [
  {
    type: 'select',
    name: 'lastFiledFederalTaxReturn',
    label: 'When did you last file a U.S. Federal tax return?',
    options: yearSelectOptions.concat({ label: 'Never', value: 'Never' }),
    placeholder: 'Select Year',
    tooltip: '',
    comment: true,
    effect: updateKeyInStore(updateKey),
    dependencies: [
      {
        type: 'radio',
        name: 'didWePrepareFederalTaxReturn',
        label: 'Did We Prepare your Federal Tax return?',
        tooltip: '',
        comment: true,
        effect: updateKeyInStore(updateKey),
        predicate: (value) => !!value,
        dependencies: [
          {
            type: 'upload',
            name: 'lastFiledFederalReturnCopy',
            label: 'Please upload a copy of last filed Federal return',
            tooltip: '',
            comment: true,
            effect: updateKeyInStore(updateKey),
            predicate: (value) => value === 'no',
          },
        ],
      },
    ],
  },
  {
    type: 'select',
    name: 'lastFiledStateTaxReturn',
    label: 'When did you last file a State Tax return',
    options: yearSelectOptions.concat({ label: 'Never', value: 'Never' }),
    placeholder: 'Select Year',
    tooltip: '',
    comment: true,
    effect: updateKeyInStore(updateKey),
    dependencies: [
      {
        name: 'taxReturnState',
        label: 'For which state(s) did you file a return?',
        type: 'state',
        tooltip: '',
        comment: true,
        effect: updateKeyInStore(updateKey),
        predicate: (value) => !!value,
      },
      {
        type: 'radio',
        name: 'didWePrepareStateTaxReturn',
        label: 'Did We Prepare your last filed State tax return?',
        tooltip: '',
        comment: true,
        effect: updateKeyInStore(updateKey),
        predicate: (value) => !!value,
        dependencies: [
          {
            type: 'upload',
            name: 'lastFiledStateReturnCopy',
            label: 'Please upload a copy of the last filed State tax return(s)',
            tooltip: '',
            comment: true,
            effect: updateKeyInStore(updateKey),
            predicate: (value) => value === 'no',
          },
        ],
      },
    ],
  },
  {
    type: 'radio',
    name: 'audited',
    label:
      'Have you (or your spouse) been audited or had correspondence with the IRS in the last 3 years?',
    tooltip: '',
    comment: true,
    effect: updateKeyInStore(updateKey),
    dependencies: [
      {
        type: 'upload',
        name: 'IRSLetterCopies',
        label: 'Upload copies of IRS letters',
        tooltip: '',
        comment: true,
        effect: updateKeyInStore(updateKey),
        predicate: (value) => value === 'yes',
      },
    ],
  },
  {
    type: 'radio',
    name: 'didYouReceiveAnyCorrespondenceFormTheIrsOrYourStateTaxAuthority',
    label:
      'Did you receive any correspondence from the IRS or your State tax authority?',
    tooltip: '',
    comment: true,
    effect: updateKeyInStore(updateKey),
  },
];

export const validationSchema = Yup.object().shape({});
